import { defineComponent as _defineComponent } from 'vue'
import type { IMessageModel } from '@tencentcloud/chat-uikit-engine';
import { withDefaults } from '../../../adapter-vue';
import { isUniFrameWork } from '../../../utils/env';
import type { IImageMessageContent } from '../../../interface';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    content: { default: () => ({}) },
    messageItem: { default: () => ({} as IMessageModel) }
  },
  setup(__props: any) {

const props = __props as { content: IImageMessageContent, messageItem: IMessageModel }



return { __sfc: true,props, isUniFrameWork }
}

})